
import * as React from 'react';
import * as rsuite from 'rsuite';
// import "bootstrap/dist/css/bootstrap.min.css";
// import 'bootstrap/dist/js/bootstrap';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import ShowMoreText from "react-show-more-text";
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as BiIcon from "react-icons/bi";

import { Markup } from 'interweave';
import PN from 'persian-number'
import { useNavigate } from 'react-router-dom'
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

// import GoogleMapReact from 'google-map-react';

const LoginIndex = () => {

    //#region Const 
    const navigate = useNavigate();
    const toaster = rsuite.useToaster();
    const [ProductGroupList, setProductGroupList] = React.useState([]);
    const [ProductBrandList, setProductBrandList] = React.useState([]);
    const [ProductDiscountList, setProductDiscountList] = React.useState([]);
    const [ProductDiscountbackground, setProductDiscountbackground] = React.useState("linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(47,72,88,1) 25%, rgba(251,250,250,1) 100%)")
    const [DiscountTitle, setDiscountTitle] = React.useState("")
    const [DiscountComment, setDiscountComment] = React.useState("")
    const [DiscountBeginDate, SetDiscountBeginDate] = React.useState("")
    const [DiscountEndDate, SetDiscountEndDate] = React.useState("")





    const GetProductGroup = () => {
        fetch(General.ApiRoute() + '/ProductGroup/SearchForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'WebIsActive': 1,
                'IsActive': -1
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                var tmp = []
                for (var i = 0; i < result.length; i++) {
                    tmp.push({
                        id: result[i].id,
                        title: result[i].title,
                        isActive: result[i].isActive,
                        webIsActive: result[i].webIsActive,
                        parentId: result[i].parentId,
                        identityNo: result[i].identityNo,
                        children: result[i].children,
                        photoTag: result[i].photoTag,

                        PhotoUrl: General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result[i].photoTag + '' + result[i].photoId + '_Img.jpg',


                    })
                }


                setProductGroupList(tmp)
            })
    }

    const GetProductDiscount = () => {

        fetch(General.ApiRoute() + '/Discount/SearchForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'IsActive': 1,
                'DiscountType': 2

            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                try {
                    if (result.length >= 1) {
                        setDiscountTitle(result[0].title)
                        setDiscountComment(result[0].comment)
                        SetDiscountBeginDate(result[0].beginDate)
                        SetDiscountEndDate(result[0].endDate)
                        var tmp = []

                        if (isMobile) {
                            for (var i = 0; i < result[0].products.length; i++) {
                                tmp.push({
                                    Id: result[0].products[i].id,
                                    ProductGroup: result[0].products[i].productGroup,
                                    Product: result[0].products[i].product,
                                    ProductBrand: result[0].products[i].productBrand,
                                    Price: result[0].products[i].lastPrice,
                                    FinalPrice: result[0].products[i].finalPrice,
                                    Discount: result[0].products[i].discount,
                                    Count: result[0].products[i].count,
                                    photoTag: result[0].products[i].photoTag,
                                    PhotoUrl: General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + result[0].products[i].productId + '' + result[0].products[i].photoTag + '_Img.jpg',


                                })
                            }
                        }
                        else {
                            var InnerItemCount = result[0].products.length / 4;
                            for (let index = 0; index < InnerItemCount; index++) {
                                tmp.push({ Items: [] })
                            }
                            var InnerIndex = 0;
                            for (let index = 0; index < InnerItemCount; index++) {
                                for (var i = InnerIndex; i < (index + 1) * 4; i++) {
                                    if (i < result[0].products.length) {

                                        tmp[index].Items.push({
                                            Id: result[0].products[i].id,
                                            ProductGroup: result[0].products[i].productGroup,
                                            Product: result[0].products[i].product,
                                            ProductBrand: result[0].products[i].productBrand,
                                            FinalPrice: result[0].products[i].finalPrice,
                                            Price: result[0].products[i].lastPrice,
                                            Discount: result[0].products[i].discount,
                                            photoTag: result[0].products[i].photoTag,
                                            PhotoUrl: General.ApiPhotoRoute() + 'Content/Images/Product/Photo/' + result[0].products[i].productId + '' + result[0].products[i].photoTag + '_Img.jpg',


                                        })
                                    }

                                }
                                InnerIndex = InnerIndex + 4;
                            }


                        }

                        setProductDiscountList(tmp)
                    }
                }
                catch (e) {
                    console.dir(e)
                }
            })





    }



    const GetProductBrand = () => {
        fetch(General.ApiRoute() + '/ProductBrand/GetForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'WebIsActive': 1,
                'IsActive': -1
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                var tmp = []

                var ColCount = isMobile ? 3 : 8
                var InnerItemCount = result.length / ColCount;
                for (let index = 0; index < InnerItemCount; index++) {
                    tmp.push({ Items: [] })
                }
                var InnerIndex = 0;
                for (let index = 0; index < InnerItemCount; index++) {
                    for (var i = InnerIndex; i < (index + 1) * ColCount; i++) {
                        if (i < result.length) {

                            tmp[index].Items.push({
                                id: result[i].id,
                                title: result[i].title,
                                PhotoUrl: General.ApiPhotoRoute() + 'Content/Images/BrandPhoto/' + result[i].id + '.jpg',


                            })
                        }

                    }
                    InnerIndex = InnerIndex + ColCount;
                }


                setProductBrandList(tmp)
            })
    }

    //  function toSlug(name) {
    //         return slugify(name, { lowercase: true, separator: "-" });
    //     }



    const ShowProduct = (id, parentId, Parenttitle, title) => {

        var NewParent = General.toSlug(Parenttitle, { latin: true })
        var Newtitle = General.toSlug(title, { latin: true })
        var Newtitle = Newtitle != NewParent ? Newtitle.replace(NewParent, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") : Newtitle;

        // navigate('/Product/' + Newtitle + "/" + parentId + "/" + id)
        navigate('/Product/' + NewParent + "/" + Newtitle + "/" + parentId + "/" + id)

    }
    const ShowGroup = (id, title) => {
        var Newtitle = General.toSlug(title, { latin: true })
        navigate('/Group/' + Newtitle + "/" + id)

    }

    //#endregion
    React.useEffect(() => {
        GetProductGroup();
        GetProductBrand();
        GetProductDiscount();
        localStorage.removeItem("ByBrand");
        localStorage.removeItem("ProductId");

        document.title = "FarmAsan.ir ";
    }, [])


    return (
        <Layout>
            
            <rsuite.Grid>

                <rsuite.Divider>
                    <rsuite.Heading className="mb-3" level={6}>دسته بندی محصولات</rsuite.Heading>
                </rsuite.Divider>

                <rsuite.Row className="justify-content-center align-items-center pb-4 mb-4">


                    {ProductGroupList.map(group => (

                        <rsuite.Col xs={12} sm={12} md={8} lg={6} className="pb-4">
                            <rsuite.Panel className='shadow-sm  ' onDoubleClick={() => ShowGroup(group.id, group.title)} bodyFill style={{ display: 'inline-block', width: isMobile ? 150 : 200 }}>


                                <rsuite.Image
                                    src={group.PhotoUrl}
                                    fallbackSrc="../../assets/images/ProductGroupPrefer.jpg"
                                    alt={group.title}
                                    placeholder={<img src="../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: '180px' }} />}
                                    zoomed

                                    style={{ width: '100%', height: '180px' }}
                                />

                                <rsuite.Panel className='fw-bold Cursor'>
                                    <rsuite.Whisper placement="autoVerticalStart" trigger={(['click'])} speaker={
                                        <rsuite.Popover full className='PopoverMenu ' >
                                            <rsuite.Dropdown.Menu className='w-100'>
                                                {group.children.map(chid =>
                                                    <rsuite.Dropdown.Item onClick={() => ShowProduct(chid.id, group.id, group.title, chid.title)}>{chid.title}</rsuite.Dropdown.Item>
                                                )}

                                            </rsuite.Dropdown.Menu>
                                        </rsuite.Popover>
                                    }>

                                        <p className='text-truncate'><BiIcon.BiCaretDown /> {group.title}</p>


                                    </rsuite.Whisper>




                                </rsuite.Panel>
                            </rsuite.Panel>

                        </rsuite.Col>
                    ))}
                </rsuite.Row>


                <rsuite.Divider className="mt-4 pt-4">
                    <rsuite.Heading className="mb-3" level={6}>برند محصولات</rsuite.Heading>
                </rsuite.Divider>
                <rsuite.Row className="justify-content-center align-items-center pb-4 mb-4">
                    <rsuite.Col xs={24} className="pb-4">

                        <Carousel className='m-3' nextLabel="" variant="dark" prevLabel="" pause="hover"  >

                            {ProductBrandList.map(Item => (
                                <Carousel.Item >
                                    {Item.Items.map(inner =>

                                        <rsuite.Col xs={8} sm={8} md={3} className='p-1'>
                                            <rsuite.Image
                                                src={inner.PhotoUrl}
                                                fallbackSrc="../../assets/images/BrandLogoPrefer.jpg"
                                                alt={Item.title}
                                                placeholder={<img src="../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '14vh', height: '10vh' }} />}
                                                zoomed

                                                style={{ width: '14vh', height: '10vh' }}
                                                className="border-radius-half"
                                            />
                                            {/* <p className="Slider-text text-truncate">{inner.title}
                                            </p> */}

                                        </rsuite.Col>
                                    )}

                                </Carousel.Item>



                            ))}
                        </Carousel>


                    </rsuite.Col>
                </rsuite.Row>

            </rsuite.Grid>
            <rsuite.Container className={ProductDiscountList.length > 0 ? 'mt-5' : 'hide'}>

                <div className='InnerBanner h-80vh mb-2'
                    style={{
                        backgroundImage: `url(${ProductDiscountbackground})`, background: `linear-gradient(90deg, rgba(47,72,88,1) 0%, rgba(76,114,139,1) 27%, rgba(251,250,250,1) 67%)`
                    }}
                >
                    <rsuite.Row>
                        {isBrowser ?
                            <BrowserView>
                                <rsuite.Col xs={24} sm={24} md={6}>
                                    <rsuite.Heading level={3} className='pe-4 fw-bolder text-center'>
                                        <br />
                                        <br />
                                        <br />
                                        <br />
                                        {DiscountTitle}
                                    </rsuite.Heading>
                                    <p className='pe-2  Font13 text-end'>
                                        <Markup content={DiscountComment} />
                                        <br />
                                        از تاریخ <text className='fw-bold'>{DiscountBeginDate}</text>  تا تاریخ <text className='fw-bold'>{DiscountEndDate}</text>  ادامه دارد
                                    </p>
                                    <br />
                                    <div className='p-2'>

                                        <rsuite.Button color="green" appearance="primary" block>نمایش تمام آیتم ها</rsuite.Button>
                                    </div>
                                </rsuite.Col>
                                <rsuite.Col xs={24} sm={24} md={18} className='p-4'>
                                    <Carousel className='m-3' nextLabel="" variant="dark" prevLabel="" pause="hover"  >

                                        {ProductDiscountList.map(Item => (
                                            <Carousel.Item className='bg-back'>
                                                {Item.Items.map(inner =>

                                                    <rsuite.Col xs={6} className='p-1'>

                                                        <rsuite.Panel className='shadow-sm bg-white ' bodyFill style={{ width: "100%", height: "50vh" }}>


                                                            <rsuite.Image
                                                                src={inner.PhotoUrl}
                                                                fallbackSrc="../../assets/images/ProductPrefer.jpg"
                                                                alt={inner.Title}
                                                                placeholder={<img src="../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: '30vh' }} />}

                                                                style={{ width: '100%', height: '30vh' }}
                                                            />

                                                            <rsuite.Panel >

                                                                <p>

                                                                    <rsuite.Heading level={5}>{inner.ProductGroup}</rsuite.Heading>
                                                                    <p className='mt-2 Font13 text-truncate'>{inner.Product}</p>
                                                                    <p className='mt-1  Font12'>برند : {inner.ProductBrand}</p>
                                                                    <p className='text-start fw-bold text-decoration-line-through' >{PN.sliceNumber(inner.Price)} ریال</p>
                                                                    <p className='text-start fw-bold text-success' >{PN.sliceNumber(inner.FinalPrice)} ریال</p>
                                                                </p>
                                                            </rsuite.Panel>
                                                        </rsuite.Panel>

                                                    </rsuite.Col>
                                                )}

                                            </Carousel.Item>



                                        ))}
                                    </Carousel>
                                </rsuite.Col>
                            </BrowserView>
                            :
                            <MobileView>

                                <rsuite.Col xs={24} sm={24} md={6}>
                                    <rsuite.Heading level={5} className='pe-4 fw-bolder text-center'>

                                        {DiscountTitle}
                                    </rsuite.Heading>
                                    <p className='pe-2  Font11 text-end'>
                                        <Markup content={DiscountComment} />
                                        از تاریخ <text className='fw-bold'>{DiscountBeginDate}</text>  تا تاریخ <text className='fw-bold'>{DiscountEndDate}</text>  ادامه دارد
                                    </p>

                                </rsuite.Col>
                                <rsuite.Col xs={24} sm={24} md={18} className='pe-4 ps-4'>
                                    <Carousel className='m-3' nextLabel="" variant="dark" prevLabel="" pause="hover"  >

                                        {ProductDiscountList.map(inner => (
                                            <Carousel.Item style={{ backgroundColor: "#cddbc2" }}>

                                                <rsuite.Panel className='shadow-sm bg-white ' bodyFill style={{ width: "100%", height: "40vh" }}>


                                                    <rsuite.Image
                                                        src={inner.PhotoUrl}
                                                        fallbackSrc="../../assets/images/ProductPrefer.jpg"
                                                        alt={inner.Title}
                                                        placeholder={<img src="../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: '20vh' }} />}

                                                        style={{ width: '100%', height: '20vh' }}
                                                    />

                                                    <rsuite.Panel >
                                                        <ShowMoreText
                                                            /* Default options */
                                                            lines={1}
                                                            more=""
                                                            less="Show less"
                                                            className="content-css Font13 fw-bold"
                                                            anchorClass="show-more-less-clickable"
                                                            // onClick={executeOnClick}
                                                            expanded={false}
                                                            truncatedEndingComponent={"... "}
                                                        >
                                                        </ShowMoreText>


                                                        <rsuite.Heading level={7}>{inner.ProductGroup}</rsuite.Heading>
                                                        <p className='mt-1 Font11'>{inner.Product}</p>
                                                        <p className='mt-1  Font11'>برند : {inner.ProductBrand}</p>
                                                        <p className='text-start'>

                                                            <small className='mt-1 text-start fw-bold text-success' > {PN.sliceNumber(inner.FinalPrice)} ریال</small>
                                                            <small className='mt-1  fw-bold text-decoration-line-through' >&nbsp;&nbsp;&nbsp;{PN.sliceNumber(inner.Price)} ریال</small>

                                                        </p>
                                                    </rsuite.Panel>
                                                </rsuite.Panel>


                                            </Carousel.Item>



                                        ))}
                                    </Carousel>
                                    <div className='p-2'>

                                        <rsuite.Button color="green" appearance="primary" block>نمایش تمام آیتم ها</rsuite.Button>
                                    </div>
                                </rsuite.Col>

                            </MobileView>
                        }
                    </rsuite.Row>
                </div>
            </rsuite.Container>
            <rsuite.Grid>
                {/*<rsuite.Divider className="mt-4 pt-4">
                    <rsuite.Heading className="mb-3" level={6}>تاریخچه تخفیفات ...  </rsuite.Heading>
                </rsuite.Divider>
                <rsuite.Row className="justify-content-center align-items-center pb-4 mb-4">
                    <rsuite.Col xs={24} className="pb-4">
                        
                        <Carousel className='m-3' nextLabel="" variant="dark" prevLabel="" pause="hover"  >

                            {ProductDiscountList.map(Item => (
                                <Carousel.Item className='bg-back'>
                                    {Item.Items.map(inner =>

                                        <rsuite.Col xs={6} className='p-1'>

                                            <rsuite.Panel className='shadow-sm bg-white ' bodyFill style={{ width: "100%", height: "50vh" }}>


                                                <rsuite.Image
                                                    src={inner.PhotoUrl}
                                                    fallbackSrc="../../assets/images/ProductPrefer.jpg"
                                                    alt={inner.Title}
                                                    placeholder={<img src="../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: '30vh' }} />}

                                                    style={{ width: '100%', height: '30vh' }}
                                                />

                                                <rsuite.Panel >
                                                    <ShowMoreText
                                                        lines={1}
                                                        more=""
                                                        less="Show less"
                                                        className="content-css Font13 fw-bold"
                                                        anchorClass="show-more-less-clickable"
                                                        expanded={false}
                                                        truncatedEndingComponent={"... "}
                                                    >
                                                    </ShowMoreText>
                                                    <p>

                                                        <rsuite.Heading level={5}>{inner.ProductGroup}</rsuite.Heading>
                                                        <p className='mt-2 Font13'>{inner.Product}</p>
                                                        <p className='mt-1  Font12'>برند : {inner.ProductBrand}</p>
                                                        <p className='text-start fw-bold text-decoration-line-through' >{PN.sliceNumber(inner.Price)} ریال</p>
                                                        <p className='text-start fw-bold text-success' >{PN.sliceNumber(inner.FinalPrice)} ریال</p>
                                                    </p>
                                                </rsuite.Panel>
                                            </rsuite.Panel>

                                        </rsuite.Col>
                                    )}

                                </Carousel.Item>



                            ))}
                        </Carousel> 


                    </rsuite.Col>
                </rsuite.Row>*/}

                <br />
                <br />
                <br />
                <rsuite.Row className='mb-3'>
                    <rsuite.Col xs={24} sm={24} md={16}>
                        <div style={isBrowser ? { width: "100%" } :
                            { marginLeft: "-40%", width: "180%", marginRight: "-40%" }}>

                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d433.54873741259553!2d52.54506809292532!3d29.621417033315133!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fb20dd0a8eeadff%3A0x3959d6d3d76574f9!2z2K7bjNin2KjYp9mGINiz2LnYr9uM2IzZvtin2LPYp9qY2YXZhNiq!5e0!3m2!1sen!2s!4v1737957537053!5m2!1sen!2s"
                                width="100%" height="400" style={{ border: "0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
                            </iframe>
                        </div>


                    </rsuite.Col>
                    <rsuite.Col xs={24} sm={24} md={8} >
                        <rsuite.Card className={isBrowser ? " pe-3 pt-4 mt-5 " : "  pe-4 ps-5"}
                            style={isBrowser ? { marginRight: "-40%", width: "140%", height: "40vh", display: "block" } :
                                {
                                    marginTop: "-10vh", height: "40vh", display: "block", paddingTop: "30px",
                                    marginLeft: "-20%", width: "140%", marginRight: "-20%"
                                }} shaded direction="row">


                            <rsuite.Heading level="6">ارتباط با ما</rsuite.Heading>

                            <p className='mt-3 fw-bold Font13'>فروشگاه مهران (فارم آسان )</p>
                            <p><b>شماره تماس  </b> 32221005 071</p>
                            <p><b>شماره تماس  </b> 32221143 071</p>
                            <p><b>شماره همراه </b> 09101172004 </p>
                            <p><b>آدرس </b>  شیراز - خیابان سعدی - پاساژ ملت - نبش خیابان فردوسی - فروشگاه مهران (فارم آسان)</p>

                        </rsuite.Card>
                    </rsuite.Col>
                </rsuite.Row>
            </rsuite.Grid>



        </Layout >
    )
}

export default LoginIndex;





